import { connect } from "react-redux";

import {
  getClientsRequest,
  supportCoordinatorsRequest,
  getCosReportingFundingTableDataRequest,
} from "store/actions/cos.actions";

import {
  getClienListSelector,
  getCaseNotesHistoryListSelector,
  getSupportCoordinator,
  getTableDataForReportingSelector,
  tableDataForReportingLoadingSelector,
  getTableDataOfCaseNotesForReportingSelector,
} from "store/selector/cos.selector";
import { getSpSetting } from "store/selector/sp.selector";
import COSReports from "./COSReports";

const mapDispatchToProps = {
  getClientList: getClientsRequest,
  getSupportCoordinatoreList: supportCoordinatorsRequest,
  getTableDataForReporting: getCosReportingFundingTableDataRequest,
};

const mapStateToProps = (state) => {
  const clientsList = getClienListSelector(state);
  const caseNotesHistoryList = getCaseNotesHistoryListSelector(state);
  const supportCoordinator = getSupportCoordinator(state);
  const tableDataForReporting = getTableDataForReportingSelector(state);
  const tableDataForReportingLoading =
    tableDataForReportingLoadingSelector(state);
  const tableDataOfCaseNotesForReporting =
    getTableDataOfCaseNotesForReportingSelector(state);
  const settings = getSpSetting(state);

  return {
    tableDataOfCaseNotesForReporting,
    tableDataForReportingLoading,
    tableDataForReporting,
    supportCoordinator,
    clientsList,
    caseNotesHistoryList,
    settings,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(COSReports);
